var map = {
	"./icon-boots.svg": "dfce",
	"./icon-compass.svg": "7322",
	"./icon-complete.svg": "53b1",
	"./icon-edit.svg": "eaaf",
	"./icon-goggles.svg": "620c",
	"./nav-point-unpinned.svg": "3722",
	"./nav-point.svg": "8121",
	"./portrait-dazed1.svg": "37c1",
	"./portrait-dazed2.svg": "1885",
	"./portrait-squint.svg": "d417",
	"./portrait.svg": "c1f6",
	"./space-command-flag.svg": "4a06",
	"./srg-logo.svg": "bf8d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f57b";